import { AppDispatch, RootState } from '..';

import { REACT_APP_COMPANY_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headerSectiontype } from '../../types';
import { headers } from '.';
import { notification } from '../../utils';

export const updateHeaderSection = (values: headerSectiontype) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-header`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }

};

export const updateSocialMedia = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-social-media`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);

    } catch (error: any) {

        notification('error', 'Failed');
        console.error(error.message);

    }

};

export const updateUIColorScheme = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-color-scheme`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);

    } catch (error: any) {

        notification('error', 'Faliled');
        console.error(error.message);

    }

};

export const updateGoogleApiKey = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-google-api-key`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);

    } catch (error: any) {

        notification('error', 'Faliled');
        console.error(error.message);

    }

};

export const updateSecretKey = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-secret-key`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);

    } catch (error: any) {

        notification('error', 'Faliled');
        console.error(error.message);

    }

};